import 'css-chunk:src/app/components/ManagerSelect/ManagerSelect.module.scss';export default {
  "ManagerSelect": "_ManagerSelect_kr7y5_1",
  "ManagerSelectDropdown": "_ManagerSelectDropdown_kr7y5_5",
  "SelectOption": "_SelectOption_kr7y5_9",
  "avatar": "_avatar_kr7y5_15"
};